import * as apiService from "./v2/apiService";
import {
  baseURL,
  AGENT_DIRECTORY,
  AGENT_DIRECTORY_SUGGEST,
  AGENT_DIRECTORY_STATES,
  AGENT_DIRECTORY_STATE,
  AGENT_DIRECTORY_PLACE,
  AGENT_DIRECTORY_BROKERAGES,
  AGENT_DIRECTORY_RESOLVE,
} from "@/constants/v2/endPoints";

const present = (params) =>
  Object.fromEntries(Object.entries(params).filter(([, value]) => value !== "" && value !== null && value !== undefined && value !== false));

const segment = (value) => encodeURIComponent(String(value || "").toLowerCase());

export async function getAgentDirectory({ lat, long, page, withBuyers, q, brokerage, network, place }) {
  return await apiService.apiCall(
    AGENT_DIRECTORY,
    "GET",
    present({ lat, long, place, page, withBuyers: withBuyers ? 1 : null, q, brokerage, network }),
  );
}

export async function getAgentDirectorySuggestions(q, lat, long) {
  return await apiService.apiCall(AGENT_DIRECTORY_SUGGEST, "GET", present({ q, lat, long }));
}

export async function getBrokerage({ name, network, page, q }) {
  return await apiService.apiCall(`${baseURL}api/v2/public/brokerage`, "GET", present({ name, network, page, q }));
}

export async function getDirectoryStates() {
  return await apiService.apiCall(AGENT_DIRECTORY_STATES, "GET");
}

export async function getDirectoryState(state) {
  return await apiService.apiCall(AGENT_DIRECTORY_STATE.replace(":state", segment(state)), "GET");
}

export async function getDirectoryPlace(state, town) {
  return await apiService.apiCall(
    AGENT_DIRECTORY_PLACE.replace(":state", segment(state)).replace(":town", segment(town)),
    "GET",
  );
}

export async function getDirectoryBrokerages({ lat, long, q, page }) {
  return await apiService.apiCall(AGENT_DIRECTORY_BROKERAGES, "GET", present({ lat, long, q, page }));
}

export async function resolveDirectoryPlace(lat, long) {
  return await apiService.apiCall(AGENT_DIRECTORY_RESOLVE, "GET", present({ lat, long }));
}
